import { Builder } from "@builder.io/react";

import { BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES } from "../BuilderComponentsName";
import { backgroundGradientOptions, textColorOptionsLimited } from "../utils/builderColorOptions";
import { S6FAQSection } from "../components/interactive-sections/S6FAQsSection";
import { getBackgroundColorInput, getBackgroundGradientInput, getPaddingInputs } from "../utils/builderSharedInputs";


Builder.registerComponent(S6FAQSection, {
    name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S6FAQs,
    inputs: [
        {
            name: "headline",
            type: "string",
            defaultValue: "Headline",
            // helperText: "Headline for the icons",
            required: true,
        },
        {
            name: "isFormattedHeadline",
            type: "boolean",
            defaultValue: true,
            friendlyName: "Formatted Headline Enabled",
            helperText: "Turn off to use UpperCase words such as 'MAXGRAFT' on the headline without formatting",
        },

        {
            name: "headlineColor",
            type: "string",
            defaultValue: "Blue",
            friendlyName: "Headline Color",
            enum: textColorOptionsLimited,
            // helperText: "Color of the headline text",
            required: false,
        },
        {
            name: 'faqs',
            friendlyName: 'FAQs',
            type: 'list',
            required: true,
            helperText: 'Add FAQ items',
            defaultValue: [{
                question: "How effective is underarm laser hair removal?",
                answer: "The average Milan Laser client is up to 95-98% hair-free in about 7-10 treatments.",
            },
            {
                question: "Do i have to shave my armpits before laser?",
                answer: "Yes, you should shave the area before your appointment. Shaving is the only hair removal method that is safe to use before laser hair removal.",
            }],

            subFields: [
                {
                    name: 'question',
                    type: 'longText',
                    required: true,
                    helperText: 'Enter the faq question.',
                },
                {
                    name: 'answer',
                    type: 'longText',
                    required: true,
                    helperText: 'Enter the answer. Available variables: {{clinicCount}}, {{totalReviews}}, {{stateCount}}, {{treatmentsPerMonth}}',
                },
            ],
        },
        {
            name: "isFormattedQuestion",
            type: "boolean",
            defaultValue: true,
            friendlyName: "Formatted FAQs Question Enabled",
            helperText: "Turn off to use UpperCase words such as 'MAXGRAFT' on the question without formatting",
        },
        {
            name: "questionColor",
            type: "string",
            defaultValue: "Turquoise",
            friendlyName: "Question Color",
            enum: textColorOptionsLimited,
        },
        {
            name: "answerColor",
            type: "string",
            defaultValue: "Navy",
            friendlyName: "Answer Color",
            enum: textColorOptionsLimited,
        },
        ...getBackgroundColorInput({
            backgroundColorName: "backgroundColor",
            defaultValue: "White",
        }),
        ...getBackgroundGradientInput({
            backgroundGradientList: backgroundGradientOptions,
        }),
        ...getPaddingInputs({
            desktopTop: "large",
            desktopBottom: "large",
            mobileTop: "medium",
            mobileBottom: "medium"
        })
    ],
    friendlyName: "S6 FAQs",
});

